import * as React from "react";

function SvgProfileUserLogo(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={164} height={164} {...props}>
        <g data-name="Group 12124" transform="translate(-248 -200)">
          <circle data-name="Ellipse 915" cx={82} cy={82} r={82} transform="translate(248 200)" fill="#cde4f2" />
          <path
            d="M329.741 242a24.325 24.325 0 00-17.364 7.221 24.508 24.508 0 00-7.196 17.419 24.49 24.49 0 007.2 17.422 24.323 24.323 0 009.48 5.923 28.517 28.517 0 00-3.691 1.29A29.835 29.835 0 00300 318.78a3.211 3.211 0 106.421 0 23.328 23.328 0 1146.655 0 3.211 3.211 0 106.421 0 30.136 30.136 0 00-2.355-11.623 29.936 29.936 0 00-15.826-15.882 30.574 30.574 0 00-3.691-1.29 24.335 24.335 0 009.475-5.922 24.522 24.522 0 007.2-17.423 24.477 24.477 0 00-7.2-17.419A24.342 24.342 0 00329.741 242zm-.009 42.841a18.191 18.191 0 01-18.139-18.201 18.138 18.138 0 1136.276 0 18.189 18.189 0 01-18.137 18.201z"
            fill="#fff"
          />
        </g>
      </svg>
    </span>
  );
}

export default SvgProfileUserLogo;
